import Flickity from "flickity"
import {getElement, getElements} from "./utils/getElement";

const initHeroSlider = () => {
    const heroSliders = getElements('.js-hero-slider')
    
        if (heroSliders.length) {
            heroSliders.map(slider => {
                new Flickity(slider, {
                    cellAlign: 'center',
                    contain: false,
                    imagesLoaded: true,
                    true: false,
                    pageDots: false,
                    adaptiveHeight: true
                });
            })
        }
}

export {initHeroSlider}